import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const MapPinAlt = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8.375 5.98079C8.375 7.19157 7.36764 8.1731 6.125 8.1731C4.88236 8.1731 3.875 7.19157 3.875 5.98079C3.875 4.77001 4.88236 3.78848 6.125 3.78848C7.36764 3.78848 8.375 4.77001 8.375 5.98079Z" strokeLinejoin="round" />;
    t2 = <path d="M11.75 5.81213C11.75 10.4323 6.125 14.75 6.125 14.75C6.125 14.75 0.5 10.4323 0.5 5.81213C0.5 2.87832 3.0184 0.5 6.125 0.5C9.2316 0.5 11.75 2.87832 11.75 5.81213Z" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="outline" viewBox="0 0 13 16">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { MapPinAlt };